import React from 'react';
import PropTypes from 'prop-types';

const SvgBasketIcon = ({ color, ...props }) => {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 7.393v.643c0 .532-.336.964-.75.964H17l-.816 7.344c-.106.95-.739 1.656-1.485 1.656H3.301c-.747 0-1.38-.706-1.485-1.656L1 9H.75C.336 9 0 8.568 0 8.036v-.643c0-.533.336-.964.75-.964h2.104l3.337-5.9c.325-.574.95-.7 1.397-.283.447.418.546 1.222.22 1.796L5.329 6.43h7.345L10.19 2.042c-.325-.574-.226-1.378.22-1.796.447-.418 1.073-.29 1.398.284l3.337 5.899h2.104c.414 0 .75.431.75.964Zm-8.25 7.071v-4.5C9.75 9.432 9.414 9 9 9s-.75.432-.75.964v4.5c0 .533.336.965.75.965s.75-.432.75-.965Zm3.5 0v-4.5c0-.532-.336-.964-.75-.964s-.75.432-.75.964v4.5c0 .533.336.965.75.965s.75-.432.75-.965Zm-7 0v-4.5C6.25 9.432 5.914 9 5.5 9s-.75.432-.75.964v4.5c0 .533.336.965.75.965s.75-.432.75-.965Z"
        fill={color || '#828282'}
      />
    </svg>
  );
};

export default SvgBasketIcon;

SvgBasketIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
